<template>
  <el-row :gutter="15">
    <el-col :span="10">
      <el-card
        header="Key Fields"
        shadow="never"
      >
        <PeekKeyFields :pickup="pickup" />
      </el-card>
    </el-col>

    <el-col :span="14">
      <el-row :gutter="15">
        <el-col :span="12">
          <el-row class="mb-3">
            <el-col>
              <el-card
                header="Sender"
                shadow="never"
              >
                <PickupPeekSender :pickup="pickup" />
              </el-card>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-card
                header="Notes"
                shadow="never"
              >
                <PickupPeekNotes :pickup="pickup" />
              </el-card>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="12">
          <el-row class="mb-3">
            <el-col>
              <el-card
                header="Receiver"
                shadow="never"
              >
                <PickupPeekReceiver :pickup="pickup" />
              </el-card>
            </el-col>
          </el-row>

          <el-row>
            <el-col>
              <el-card
                header="Attached Consignments"
                shadow="never"
              >
                <PeekConsignments :pickup="pickup" />
              </el-card>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import PeekKeyFields from '@/components/Application/CustomerService/Pickups/Pickup/Peek/KeyFields'
import PickupPeekSender from '@/components/Application/CustomerService/Pickups/Pickup/Peek/Sender'
import PickupPeekReceiver from '@/components/Application/CustomerService/Pickups/Pickup/Peek/Receiver'
import PeekConsignments from '@/components/Application/CustomerService/Pickups/Pickup/Peek/Consignments'
import PickupPeekNotes from '@/components/Application/CustomerService/Pickups/Pickup/Peek/Notes'

export default {
  components: {
    PeekKeyFields,
    PickupPeekSender,
    PickupPeekReceiver,
    PeekConsignments,
    PickupPeekNotes
  },
  props: {
    pickup: {
      type: Object,
      required: true
    }
  }
}
</script>
